import React from 'react';
import DownwardsArrow from '../assets/SVGs/DownwardsIcon.svg';
import UpwardsArrow from '../assets/SVGs/UpwardsIcon.svg';
import { colors } from '../theme/color-palette';

export const getIcon = (sign) => {
	let icon;
	if (sign >= 0) {
		icon = UpwardsArrow;
	} else if (sign < 0) {
		icon = DownwardsArrow;
	}

	return (
		<img
			style={{
				padding: '2px 4px',
				height: '12px',
				width: '8px',
			}}
			src={icon}
			alt="icon"
		/>
	);
};

export const colorCoding = (sign) => {
	if (sign === 1) {
		return colors.SUCCESS_MD;
	} else if (sign === -1) {
		return colors.ERROR_MD;
	} else return colors.DARK_GREY;
};
